import { render, staticRenderFns } from "./RevenueListSelector.vue?vue&type=template&id=36953c96&scoped=true&"
import script from "./RevenueListSelector.vue?vue&type=script&lang=js&"
export * from "./RevenueListSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36953c96",
  null
  
)

export default component.exports